import { useMemo } from "react";

import TractionMatrix from "../TractionMatrix";
import buildTractionData from "../builders/buildTractionData";

export default function TractionSection({
    tracaoMonitor
}) {

    const dataByCar = useMemo(
        () => buildTractionData(tracaoMonitor),
        [tracaoMonitor]
    );

    return (
        <TractionMatrix
            cars={[1, 2, 3, 4, 5, 6, 7, 8]}
            categoryLabel="Tração e Alimentação"
            dataByCar={dataByCar}
        />
    );
}